import {writable} from "svelte/store"
import {load,save,remove} from "../shared/api.js"

let { subscribe, set, update } = writable({});
export let basket = {
  subscribe,
  load: async (currency) => set((await load({ url:"/duocms/api/basket"+ (currency ? "?currency="+currency : "") })).data),
  remove: async (id)=> set((await remove({ url:"/duocms/api/basket/"+id})).data),
  update: async ({id,qty})=> set((await save({ url:"/duocms/api/basket/", method:"PUT", data:{id, qty} })).data),
  add: async ({id,qty})=> set((await save({ url:"/duocms/api/basket/", method:"POST", data:{id, qty} })).data),
  postage: async (qs) => set((await load({ url:"/duocms/api/basket?"+ (Object.keys(qs).map((k)=> k+"="+qs[k]).join("&")) })).data)
}

export let open = writable(null)

function getPostage(){
	const { subscribe, set } = writable([]);
	return {
		subscribe,
		load: async () => set((await load({url:"/duocms/api/postage"})).data)
	};
}

export let postage = getPostage()